import { Link, styled } from '@mui/material'

import ArrowIcon from '../../assets/arrow_outward.svg'

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.main,
  whiteSpace: 'nowrap',
  '&::after': {
    content: `url(${ArrowIcon})`,
    marginLeft: theme.spacing(0.5),
    position: 'relative',
    top: 6,
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(1),
    },
  },
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(-0.75),
    display: 'block',
  },
}))
